<template>
  <div>
    <or-layout>
      <h3 class="page">
        校区信息
        <a-button type="primary" icon="left" @click="goPage">返回</a-button>
      </h3>

      <div class="main">
        <a-row class="row" :gutter="16" v-if="campusInfo.info && campusInfo.data">
          <a-col :span="16">
            <h2 class="title">{{ campusInfo.info.name }}</h2>
            <div class="row">校长:{{ campusInfo.info.campusadmin }}</div>
          </a-col>
          <a-col :span="2">
            <a-statistic title="学生" :value="campusInfo.data.studentcount" />
          </a-col>
          <a-col :span="2">
            <a-statistic title="任务" :value="campusInfo.data.missioncount" />
          </a-col>
          <a-col :span="2">
            <a-statistic title="参测率" :value="campusInfo.data.cancelv">
              <template #suffix>
                <span>%</span>
              </template>
            </a-statistic>
          </a-col>
          <a-col :span="2">
            <a-statistic title="正确率" :value="campusInfo.data.zhengquelv">
              <template #suffix>
                <span>%</span>
              </template>
            </a-statistic>
          </a-col>
        </a-row>
        <a-tabs class="row" type="card" @change="tabsChange">
          <a-tab-pane tab="班级" key="grade">
            <a-row :gutter="[16, 16]" type="flex" justify="space-between">
              <a-col :span="5">
                <a-button type="primary" @click="addSquad" style="margin-bottom: 10px;">新增班级</a-button>
              </a-col>
              <a-col>
                <a-form layout="inline">
                  <a-form-item>
                    <a-select v-model="gradeSearchForm.course_id" placeholder="课程" style="width: 220px;" allow-clear>
                      <a-select-option v-for="(item) in courseList" :key="item.id" :value="item.id">{{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item>
                    <a-select v-model="gradeSearchForm.opening" placeholder="开班状态" allow-clear style="width: 120px;">
                      <a-select-option :key="0" :value="0">未开班</a-select-option>
                      <a-select-option :key="1" :value="1">已开班</a-select-option>
                      <a-select-option :key="2" :value="2">已结班</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item>
                    <a-select v-model="gradeSearchForm.status" placeholder="班级状态" allow-clear style="width: 120px;">
                      <a-select-option :key="0" :value="0">禁用</a-select-option>
                      <a-select-option :key="1" :value="1">可用</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item>
                    <a-select v-model="gradeSearchForm.year_name" placeholder="年度" allow-clear style="width: 120px;">
                      <a-select-option :key="0" value="2020">2020年</a-select-option>
                      <a-select-option :key="1" value="2021">2021年</a-select-option>
                      <a-select-option :key="2" value="2022">2022年</a-select-option>
                      <a-select-option :key="3" value="2023">2023年</a-select-option>
					  <a-select-option :key="4" value="2024">2024年</a-select-option>
					   <a-select-option :key="5" value="2025">2025年</a-select-option>
					    <a-select-option :key="6" value="2026">2026年</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item>
                    <a-select v-model="gradeSearchForm.semester_name" placeholder="季度" allow-clear style="width: 120px;">
                      <a-select-option :key="0" value="寒假">寒假</a-select-option>
                      <a-select-option :key="1" value="春季">春季</a-select-option>
                      <a-select-option :key="2" value="暑假">暑假</a-select-option>
                      <a-select-option :key="3" value="秋季">秋季</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item>
                    <a-select v-model="gradeSearchForm.grade_id" placeholder="年级" style="width: 220px;" allow-clear>
                      <a-select-option v-for="(item) in nianjiList" :key="item.id" :value="item.id">{{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item>
                    <a-select v-model="gradeSearchForm.is_famission" placeholder="是否发送任务" allow-clear
                      style="width: 120px;">
                      <a-select-option :key="0" value="0">不发送</a-select-option>
                      <a-select-option :key="1" value="1">发送</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item>
                    <a-input placeholder="班级名称" v-model="gradeSearchForm.keyword" @keyup.enter="tableSearch"></a-input>
                  </a-form-item>
                  <a-form-item>
                    <a-button type="primary" htmlType="submit" icon="search" @click="searchGrade"></a-button>
                  </a-form-item>
                </a-form>
              </a-col>
            </a-row>
            <a-table :dataSource="campusGradeList" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
              @change="onPaginationChange" bordered>
              <a-table-column key="gradename" title="年级" data-index="gradename" />
              <a-table-column key="name" title="班级" data-index="name" />
              <a-table-column key="campusname" title="校区" data-index="campusname" />
              <a-table-column key="coursename" title="课程包" data-index="coursename" />
              <a-table-column key="year_name" title="年度" data-index="year_name" />
              <a-table-column key="semester_name" title="季度" data-index="semester_name" />
              <a-table-column key="amount" title="计划人数" data-index="amount" />
              <a-table-column key="code" title="班级码" data-index="code" />
              <a-table-column key="banzhuren" title="班主任" data-index="banzhuren" />
              <a-table-column key="teacher" title="任课老师" data-index="teacher" />
              <a-table-column key="is_famission" title="发送任务" data-index="is_famission" />
              <a-table-column key="type" title="班型">
                <template slot-scope="item">
                  <span v-if="item.type == 0">培优班</span>
                  <span v-if="item.type == 1">提高班</span>
                  <span v-if="item.type == 2">英才班</span>
                  <span v-if="item.type == 3">1对1VIP班</span>
                  <span v-if="item.type == 4">体验课</span>
				   <span v-if="item.type == 5">冲刺班</span>
                </template>
              </a-table-column>

              <a-table-column key="interval" title="时间">
                <template slot-scope="item">
                  <span v-if="item.interval == 1">每周六</span>
                  <span v-if="item.interval == 2">每周天</span>
                  <span v-if="item.interval == 3">每天</span>
                  <span v-if="item.phase == 1">第一阶段</span>
                  <span v-if="item.phase == 2">第二阶段</span>
                  <span v-if="item.phase == 3">第三阶段</span>
                  <span v-if="item.phase == 4">第四阶段</span>
				  <span v-if="item.phase == 5">第五阶段</span>
                </template>
              </a-table-column>
              <a-table-column key="opening" title="开班状态">
                <template slot-scope="item">
                  <span v-if="item.opening == 0">未开班</span>
                  <span v-if="item.opening == 1">已开班</span>
                  <span v-if="item.opening == 2">已结班</span>
                </template>
              </a-table-column>
              <a-table-column key="status" width="100px;" title="状态">
                <template slot-scope="item">
                  <span v-if="item.status == 1">可用</span>
                  <span v-if="item.status == 0">已禁用</span>
                </template>
              </a-table-column>
              <a-table-column key="active" title="操作">
                <template slot-scope="item">
                  <Squadinfo v-bind:itemdata="item"></Squadinfo>
                  <!--  <router-link :to="{path:'/orgquadinfo',query:{id:item.id}}">查看详情</router-link> -->
                  <a-button v-if="item.status == 1" @click="tableEdit(item)" class="active_btn" size="small" type="link">编辑
                  </a-button>
                  <a-button v-if="item.status == 0" @click="changeSquadStatus({ id: item.id, status: 1, pid: item.pid })"
                    class="active_btn" size="small" type="link">启用
                  </a-button>
                  <a-button v-if="item.status == 1" @click="changeSquadStatus({ id: item.id, status: 0, pid: item.pid })"
                    class="active_btn" size="small" type="link">禁用
                  </a-button>
                </template>
              </a-table-column>
            </a-table>
          </a-tab-pane>
          <a-tab-pane tab="教师" key="teacher">
            <teacherlist :id="campus_id"></teacherlist>
          </a-tab-pane>
          <a-tab-pane tab="校区配置" key="campusconfig">
            <campusbasicconfig :campus="campus_id"></campusbasicconfig>
          </a-tab-pane>
        </a-tabs>
      </div>

      <a-modal :visible="squadVisible" title="班级信息编辑" @ok="squadModalSave" :destroyOnClose="true" @cancel="modalCancel">
        <a-form>
			
          <a-row :gutter="[16, 16]" type="flex" justify="space-between">
            <a-col :span="12">
              <a-input type="hidden" v-model="form.id" />
              <a-form-item>
                <a-input v-model="form.name" placeholder="班级名字" />
              </a-form-item>
              <a-form-item>
                <a-input v-model="form.jcname" placeholder="简称" />
              </a-form-item>
              <a-form-item>
                <a-input type="number" v-model="form.amount" placeholder="班级人数" />
              </a-form-item>

              <!--<a-form-item>
                        <a-input type="text" v-model="form.live_path" placeholder="直播地址"/>
                    </a-form-item>-->
              <a-form-item>
                <a-select v-model="form.interval" placeholder="间隔时间" allow-clear>
                  <a-select-option :key="4" :value="4">每周五</a-select-option>
                  <a-select-option :key="0" :value="1">每周六</a-select-option>
                  <a-select-option :key="1" :value="2">每周天</a-select-option>
                  <a-select-option :key="2" :value="3">每天</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item>
                <a-select v-model="form.phase" placeholder="阶段" allow-clear>
                  <a-select-option :key="0" :value="1">第一阶段(上午8:00-10:00)</a-select-option>
                  <a-select-option :key="1" :value="2">第二阶段(上午10:00-12:00)</a-select-option>
                  <a-select-option :key="2" :value="3">第三阶段(下午14:30-16:30)</a-select-option>
                  <a-select-option :key="3" :value="4">第四阶段(下午16:30-18:30)</a-select-option>
				   <a-select-option :key="4" :value="5">第五阶段(下午18:30-20:30)</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item>
                <a-select v-model="form.grade_id" placeholder="年级" allow-clear>
                  <a-select-option v-for="(item) in gradeList" :key="item.id" :value="item.id">{{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item>
                <a-select show-search optionFilterProp="children" v-model="form.instructor" placeholder="班主任" allow-clear>
                  <a-select-option v-for="(item) in teacherList" :key="item.id"
                    :value="item.id">{{ item.nickname }}-{{ item.mobile }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item>
                <a-select v-model="form.admin_id" optionFilterProp="children" show-search placeholder="任课老师">
                  <a-select-option v-for="(item) in teacherList" :key="item.id"
                    :value="item.id">{{ item.nickname }}-{{ item.mobile }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item>
                <a-select v-model="form.course_id" optionFilterProp="children" show-search placeholder="课程">
                  <a-select-option v-for="(item) in courseList" :key="item.id" :value="item.id">{{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item>
                <a-select v-model="form.type" placeholder="班型" allow-clear>
                  <a-select-option :key="0" :value="0">培优班</a-select-option>
                  <a-select-option :key="1" :value="1">提高班</a-select-option>
                  <a-select-option :key="2" :value="2">英才班</a-select-option>
                  <a-select-option :key="3" :value="3">1对1VIP班</a-select-option>
                  <a-select-option :key="4" :value="4">体验课</a-select-option>
				   <a-select-option :key="5" :value="5">冲刺班</a-select-option>
                </a-select>
              </a-form-item>


              <a-form-item>
                <a-select v-model="form.semester_name" placeholder="季度" allow-clear>
                  <a-select-option :key="0" value="寒假">寒假</a-select-option>
                  <a-select-option :key="1" value="春季">春季</a-select-option>
                  <a-select-option :key="2" value="暑假">暑假</a-select-option>
                  <a-select-option :key="3" value="秋季">秋季</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item>
                <a-select v-model="form.subject" placeholder="学科" allow-clear>
                  <a-select-option :key="1" :value="1">数学</a-select-option>
                  <a-select-option :key="2" :value="2">英语</a-select-option>
                  <a-select-option :key="3" :value="3">语文</a-select-option>
                  <a-select-option :key="4" :value="4">化学</a-select-option>
                  <a-select-option :key="5" :value="5">物理</a-select-option>

                </a-select>
              </a-form-item>

              <a-form-item>
                <a-select v-model="form.year_name" placeholder="年度" allow-clear>
                  <a-select-option :key="0" value="2021">2021年</a-select-option>
                  <a-select-option :key="1" value="2022">2022年</a-select-option>
                  <a-select-option :key="2" value="2023">2023年</a-select-option>
				  <a-select-option :key="3" value="2024">2024年</a-select-option>
				    <a-select-option :key="4" value="2025">2025年</a-select-option>
					 <a-select-option :key="5" value="2026">2026年</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item>
                <a-select v-model="form.opening" placeholder="开班状态" allow-clear>
                  <a-select-option :key="0" :value="0">未开班</a-select-option>
                  <a-select-option :key="1" :value="1">已开班</a-select-option>
                  <a-select-option :key="2" :value="2">已结班</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item>
                <a-select v-model="form.is_famission" placeholder="是否发送任务" allow-clear>
                  <a-select-option :key="1" :value="1">发送</a-select-option>
                  <a-select-option :key="0" :value="0">不发送</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
    </or-layout>
  </div>
</template>


<script>
import moment from "moment";
import teacherlist from './orgcampusteacherlist.vue';
import Squadinfo from '@/views/basic/orgquadinfomodel.vue';
import campusbasicconfig from '@/views/basicconfig/campusbasicconfig.vue';

export default {
  components: { teacherlist, Squadinfo, campusbasicconfig },
  data() {
    return {
      pageinfo: { total: 1, current: 1, pageSize: 10 },
      campus_id: "",
      nianjiList: [],
      squadChapterList: [],
      squad_info: { data: undefined, info: undefined },
      campusGradeList: [],
      teacherList: [],
      mission_type: "",
      loading: false,
      campusInfo: { info: undefined, data: undefined },
      squadVisible: false,
      teacheraddvisible: false,
      courseChapterList: [],
      courseList: [],
      courseTeacherList: [],
      gradeList: [],
      form: {
        name: undefined,
        campus_id: undefined,
        course_id: undefined,
        grade_id: undefined,
        admin_id: undefined,
        instructor: undefined,
        amount: undefined,
        opening: undefined,
        interval: undefined,
        phase: undefined,
        jcname: undefined

      },
      gradeSearchForm: {
        campus_id: undefined
      }
    }
  },
  mounted() {
    this.campus_id = this.$route.query.id;
    this.form.campus_id = this.campus_id;
    this.gradeSearchForm.campus_id = this.campus_id;
    this.getCampusInfo();
    this.getCampusSquadList();
    this.getCampusTeacherList();
    this.getCourseList();
    this.getGradeList();
    this.getNianjiList();
  },

  methods: {
    searchGrade() {
      this.pageinfo.current = 1;
      this.getCampusSquadList();
    },
    changeTimeRange(val) {
      this.from.start_time = parseInt(val[0].valueOf() / 1000);
      this.from.end_time = parseInt(val[1].valueOf() / 1000);
    },
    getCampusInfo() {
      this.$axios
        .post("/api/OrgCampus/getinfo", {
          data: { campus_id: this.campus_id }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.campusInfo = res.data;
          }
        })
        .catch(err => {
          console.error(err);
        });

    },
    getNianjiList() {
      this.$axios
        .post("/api/BasicGrade/index", {
          pageinfo: {
            pageSize: 999
          }
        })
        .then((res) => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.nianjiList = res.data.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    tabsChange(key) {
      this.pageinfo.current = 1;
      switch (key) {
        case "grade":
          this.getCampusSquadList();
          break;
        case "teacher":
          this.getTeacherList()
          break;
        default:
          break;
      }
    },
    getGradeList() {
      this.$axios
        .post("/api/BasicGrade/index")
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.gradeList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    tableEdit(item) {
      this.squadVisible = true;
      item = JSON.parse(JSON.stringify(item));
      this.getCampusTeacherList();
      this.form = item;
      this.squadVisible = true;
    },
    getCampusTeacherList() {
      this.$axios
        .post("/api/OrgCampus/getteacher", { data: { org_id_by_campus_id: this.campus_id }, pageinfo: { pageSize: 9999 } })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.teacherList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    getCourseList() {
      this.$axios
        .post("/api/BasicCourse/index", { data: { status: 1 }, pageinfo: { pageSize: 9999 } })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.courseList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getCampusSquadList() {
      this.loading = true;
      this.$axios
        .post("/api/OrgSquad/getcampussquad", {
          data: this.gradeSearchForm,
          pageinfo: this.pageinfo
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.campusGradeList = res.data.data;
            this.pageinfo = res.data.pageinfo;
          }
          this.loading = false;
        })
        .catch(err => {
          console.error(err);
        });
    },
    changeSquadStatus(data) {
      this.$axios
        .post("/api/OrgSquad/edit", { data })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getCampusSquadList();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    changeTeacherStatus(data) {
      this.$axios
        .post("/api/Admin/edit", { data })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getTeacherList()
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getTeacherList() {
      this.loading = true;
      this.$axios
        .post("/api/OrgCampus/getteacher", {
          pageinfo: this.pageinfo,
          data: { org_id_by_campus_id: this.campus_id }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.teacherList = res.data.data;
            this.pageinfo = res.data.pageinfo;
          }
          this.loading = false;
        })
        .catch(err => {
          console.error(err);
        });
    },
    onPaginationChange(item) {
      this.pageinfo.current = item.current;
      this.getCampusSquadList();
    },
    onTeacherPaginationChange(item) {
      this.getTeacherList();
      this.pageinfo.current = item.current;
    },
    goPage() {
      this.$router.push('/orgcampus');
    },
    addSquad() {
      this.squadVisible = true;
      this.form.id = undefined;
    },
    addteacher() {
      this.teacheraddvisible = true;
    },
    modalCancel() {
      this.squadVisible = false;
      if (this.form.id != undefined) {
        this.form = {
          name: undefined,
          campus_id: undefined,
          course_id: undefined,
          grade_id: undefined,
          admin_id: undefined,
          instructor: undefined,
          amount: undefined,
          opening: undefined
        }
      }
    },
    teachermodalCancel() {
      this.teacheraddvisible = false;
    },
    squadModalSave() {
      let _this = this;
      if (!this.form.course_id) {
        _this.$error({
          title: "错误",
          content: "必须选择所属课程",
          okText: "确定"
        });
        return false;
      }
      let url = "/api/OrgSquad/edit";
      if (!this.form.id || this.form.id.trim() === '') {
        url = "/api/OrgSquad/add";
      }
      this.$axios
        .post(url, { data: this.form })
        .then(res => {
          if (res.code != 200) {
            _this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            _this.getCampusSquadList();
            _this.squadVisible = false;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    moment
  }
};
</script>


<style lang="less" scoped>
.main {
  margin-top: 1.5rem;
}

.row {
  margin-top: 1rem;
}

.title {
  font-weight: 700;
  font-family: 微软雅黑, tahoma;
}

.page {
  display: flex;
  justify-content: space-between;
}
</style>